<template>
  <div>
    <form enctype="multipart/form-data" novalidate
        @drop="filesDropped"
        class="text-center"
      >

      <div class="upload-dropbox">
        <input type="file" 
            class="upload-input-file" 
            ref="fileInput"
            name="ufile" 
            v-bind="attrMultiple"
            @change="filesChanged"
            @click="onClickFileInput"
            :accept="accept" />

          <b-icon-upload font-scale="4" class="align-middle"></b-icon-upload>
         
          <p class="upload-hint">{{hint}}</p>
      </div>
    </form>
  </div>
</template>



<script>
// import Vue from 'vue';
import {debug, isMSIE} from './globals';

// import { BIcon } from 'bootstrap-vue';
import { BIconUpload } from 'bootstrap-vue';


export default {
  components: {
    // BIcon,
    BIconUpload
  },

  props: [ 'accept', // image/* - switch to attachType?
    'hint',
    'isMultiple'
  ],


  computed: {
    attrMultiple: function() {
      return (this.isMultiple == "true") ? {multiple: true} : null
    },

    // isMSIE: () => isMSIE()
  },


  created() {
    debug('FileUploadLauncher created: isMultiple=' + this.isMultiple);
  },


  methods: {
    filesDropped(event) {
      debug('FileUploadLauncher filesDropped');

      // use this code for IE only!!!
      // filesChanged is not fired in IE
      // if (this.isMSIE) {
      if (isMSIE()) {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer.files.length) {
          debug('FileUploadLauncher filesDropped: emit selected-files');
          this.$emit('selected-files',
            {fieldName: 'ufile', fileList: event.dataTransfer.files});
        }
      }
    },


    filesChanged(event) {
      debug('FileUploadLauncher filesChanged');

      if (event.target.files.length) {
        debug('FileUploadLauncher filesChanged: emit selected-files');
        this.$emit('selected-files',
          {fieldName: event.target.name, fileList: event.target.files});
      }
    },


    onClickFileInput() {
      // fix for IE which doesn't fire 'change' event if selected the same file twice
      debug('FileUploadLauncher onClickFileInput');
      this.$refs.fileInput.value = null
    },


    initiate() {
      // for programmatic initiation
      debug('FileUploadLauncher initiate');
      this.$refs.fileInput.click();
    }
  }, // methods
}
</script>


<style scoped>
.main-container {
  position: relative;
  padding: 0;
}


.upload-dropbox {
  background: lightcyan;
  border: 1px solid #00BAD5;
  border-radius: 5px;
  color: dimgray;
  position: relative;
  padding: 10px;
  width: 200px;
  height: 200px;
}


/* .upload-dropbox: narrow screen */
@media (max-width: 767px) {
  .upload-dropbox {
    margin-left: auto !important;
    margin-right: auto !important;
  }
}

.upload-dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 5px 5px;
}

.upload-input-file {
  opacity: 0;
  overflow: hidden;
  min-height: 200px;
  width: 100%;
  position: absolute;
  cursor: pointer;
  left: 0px;
  top: 0px;
  margin: 0;
  padding: 0;
}

.upload-icon {
  margin-top: 15px;
  font-size: 3em;
  color: #00BAD5;
}

.upload-hint {
  line-height: 1em;
}


</style>


